<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>
<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'app',
  comments: {},
  data(){
    return {
      locale: zh_CN,
    }
  },
};
</script>
<style>
#app {
  width: 100%;
}
</style>
